// extracted by mini-css-extract-plugin
export default {"dev":"Header_dev__WStwT","logoWrapper":"Header_logoWrapper__yjK54","logo":"Header_logo__P0Ats","user":"Header_user__dGoMZ"};